import { Injectable } from '@angular/core';
import {
  MissingTranslationHandler,
  MissingTranslationHandlerParams
} from '@ngx-translate/core';

@Injectable()
export class MyMissingTranslationHandler
  implements MissingTranslationHandler {

  handle(params: MissingTranslationHandlerParams) {
    console.warn(`Missing translation: ${params.key}`);
    return params.key;
  }
}
